/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmd_PriorityInputs */

const en_cmd_priority = /** @type {(inputs: Cmd_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change priority`)
};

const de_cmd_priority = /** @type {(inputs: Cmd_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priorität ändern`)
};

/**
* | output |
* | --- |
* | "Change priority" |
*
* @param {Cmd_PriorityInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cmd_priority = /** @type {((inputs?: Cmd_PriorityInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmd_PriorityInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cmd_priority(inputs)
	return en_cmd_priority(inputs)
});